angular.module('picmonic-common').factory('SmartlookService', [
  function () {
    return {
      setUserInfo: function (user) {
        if (typeof smartlook === 'function') {
          smartlook('identify', user.user_id, user);
        }
      },
    };
  },
]);
